import React from 'react';
import { styled } from '@linaria/react';
import { RangeSizesType } from 'types/Sizes';
import { ColorPath } from 'types/Theme';
import ContentWrapper from '@daedalus/atlas/helpers/ContentWrapper';
import { Stack } from '@daedalus/atlas/helpers/Stack';
import { Price } from '@daedalus/atlas/Price';
import { SkeletonLoader } from '@daedalus/atlas/SkeletonLoader';
import { Text } from '@daedalus/atlas/Text';
import { defaultCurrencyCode } from '@daedalus/core/src/localization/business/currency';
import { FormattedMessageWrapper } from '@daedalus/core/src/localization/components/FormattedMessage';
import { NUMBER_OF_DECIMALS_FOR_PRICE } from '.';
interface DisclaimersPropsType {
  displayCurrencyCode?: string;
  chargeableCurrencyCode?: string;
  propertyCurrencyCode?: string;
  totalUpFront?: number;
  totalUpFrontChargeablePrice?: number;
  showCurrencyConversionText: boolean;
  showFeesPayableAtPropertyText: boolean;
  isPriceLoading?: boolean;
  paddingTop?: RangeSizesType;
  colorPath?: ColorPath;
  /**
   * Space between the disclaimer texts
   */
  spaceBetween?: RangeSizesType;
}
interface FormattedPriceProps {
  amount: number;
  currencyCode: string;
}
const DisclaimerText = /*#__PURE__*/styled('div')({
  name: "DisclaimerText",
  class: "dfglx8o",
  propsAsIs: false
});
const StyledPrice = /*#__PURE__*/styled('span')({
  name: "StyledPrice",
  class: "si69mxg",
  propsAsIs: false
});
const DisclaimerTextSkeleton = () => {
  return <DisclaimerText>
      <SkeletonLoader height={18} />
      <SkeletonLoader height={18} />
    </DisclaimerText>;
};
const _exp4 = /*#__PURE__*/() => Price;
const PriceStyled = /*#__PURE__*/styled(_exp4())({
  name: "PriceStyled",
  class: "pjjf1c1",
  propsAsIs: true
});
const FormattedPrice = ({
  amount,
  currencyCode
}: FormattedPriceProps) => <PriceStyled noStyle maximumFractionDigits={NUMBER_OF_DECIMALS_FOR_PRICE} minimumFractionDigits={NUMBER_OF_DECIMALS_FOR_PRICE} value={amount} currency={currencyCode} />;
const Disclaimers = ({
  totalUpFront,
  totalUpFrontChargeablePrice,
  chargeableCurrencyCode = defaultCurrencyCode,
  displayCurrencyCode = defaultCurrencyCode,
  propertyCurrencyCode = defaultCurrencyCode,
  showCurrencyConversionText = false,
  showFeesPayableAtPropertyText = false,
  isPriceLoading = false,
  paddingTop = 's500',
  colorPath = 'content.neutral.c600',
  spaceBetween = 's200'
}: DisclaimersPropsType) => {
  if (!showCurrencyConversionText && !showFeesPayableAtPropertyText) return null;
  if (isPriceLoading) return <DisclaimerTextSkeleton />;
  const displayCurrencyConversionText = showCurrencyConversionText && totalUpFront && totalUpFrontChargeablePrice && chargeableCurrencyCode && displayCurrencyCode;
  return <ContentWrapper paddingTop={paddingTop}>
      <Stack space={spaceBetween}>
        {displayCurrencyConversionText && <div>
            <Text variant="bodyS" colorPath={colorPath}>
              <FormattedMessageWrapper id="paymentV2.priceConversionDisclaimer" defaultMessage="You'll be charged <price>{totalUpFrontChargeablePrice}</price>, approximated as <price>{totalUpFront}</price>. Your card issuer may charge a foreign transaction fee." values={{
            totalUpFrontChargeablePrice: <FormattedPrice amount={totalUpFrontChargeablePrice} currencyCode={chargeableCurrencyCode} />,
            totalUpFront: <FormattedPrice amount={totalUpFront} currencyCode={displayCurrencyCode} />,
            price: (...msg: string[]) => <StyledPrice>{msg}</StyledPrice>
          }} />
            </Text>
          </div>}
        {showFeesPayableAtPropertyText && <div>
            <Text variant="bodyS" colorPath={colorPath}>
              <FormattedMessageWrapper id="paymentV2.priceConversionDisclaimerAtProperty" defaultMessage="Payment at property is done in local currency ({propertyCurrencyCode}). Exchange rates may vary at the time of the payment." values={{
            propertyCurrencyCode: propertyCurrencyCode.toUpperCase()
          }} />
            </Text>
          </div>}
      </Stack>
    </ContentWrapper>;
};
export default Disclaimers;

require("./Disclaimers.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./Disclaimers.tsx");